import React from 'react'
import { Link } from 'react-router-dom'

// components
import Avatar from '../avator/Avatar'

// styles
import './ProjectList.css'

export default function ProjectList({ projects }) {
  return (
    <div className="project-list">
        {projects.length === 0 && <p>No projects yet!</p>}
        {projects.map(project => (
            <Link to={`/projects/${project.id}`} key={project.id}>
                <h4>{project.name}</h4>
                <p>{project.details}</p>
                <p>Due by {project.dueDate.toDate().toDateString()}</p> 
                <div className="assigned-to">
                    <h4>Assigned to: </h4>
                    <ul>
                        {project.assignedUsersList.map(user => (
                            <li key={user.id}><Avatar image={user.photoURL} /> </li>
                        ))}
                    </ul>
                </div>
            </Link> 
        ))}
    </div>
  )
}
